var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute flex flex-col justify-center w-screen min-h-screen text-center",class:{ background: _vm.background }},[_c('h1',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('h2',[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }